/**
 * Default pagination page
 * @type {number}
 */
export const rowsPerPage = 10
